setMultiplePmListsProcessingAction